import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Popup,
  List,
  Icon,
} from 'semantic-ui-react';

export default class PopupButtonList extends Component {
  static propTypes = {
    buttonContent: PropTypes.node.isRequired,
    size: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
  }
  static defaultProps = {
    size: 'tiny',
  }
  render() {
    const data = this.props.data;
    return (
      <Popup
        className="popupList"
        trigger={
          <Button
            className="icon"
            compact
          >
            {this.props.buttonContent}
          </Button>
        }
        on="focus"
        wide="very"
        size={this.props.size}
        position="bottom center"
        basic
      >
        <div style={{ width: '70px' }}>
          <List size={this.props.size}>
            {data && data.length > 0
              ? data.map((item, id) => (
                <List.Item key={id}><Icon name="circle" color={item.iconColor || ''} /> {item.value}</List.Item>
              ))
              : ''
            }
          </List>
        </div>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PopupButtonList.jsx